import dayjs from '@/libs/dayjs.ts';
import { DATE_FORMAT } from '@/constants';

export const formatDate = (
    date: string,
    format: string = DATE_FORMAT.FULL_12H
) => {
    const datetime = date.endsWith('Z') ? date : `${date}Z`;
    return dayjs(datetime).local().format(format);
};
